// extracted by css-extract-rspack-plugin
export default {"asideHeading":"FeaturedContent-module__asideHeading__RiTxLuo"};